import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import './InsufficientFunds.scss';

// Set app element for accessibility
if (typeof document !== 'undefined') {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    Modal.setAppElement('#root');
  }
}

const InsufficientFunds = ({ isOpen, topUpUrl }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Insufficient Funds"
      overlayClassName="InsufficientFunds__Overlay"
      className="InsufficientFunds__Content"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={true}
      style={{
        overlay: {
          zIndex: 9999,
          position: 'fixed',
          backgroundColor: 'rgba(26, 26, 26, 0.5)'
        },
        content: {
          zIndex: 10000
        }
      }}
    >
      <div className="InsufficientFunds__Holder">
        <div className="InsufficientFunds">
          <div className="InsufficientFunds__Header">
            <h2>{t('insufficient_funds_title')}</h2>
          </div>
          <div className={`InsufficientFunds__Body ${topUpUrl ? 'mb-2' : ''}`}>
            <p>{t('insufficient_funds_text')}</p>
          </div>
          {topUpUrl && (
            <div className="InsufficientFunds__Actions">
              <a
                href={topUpUrl}
                target="_top"
                className="InsufficientFunds__Button"
              >
                {t('top_up_balance')}
              </a>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default InsufficientFunds;
